var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main"},[_c('Header'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wrong"},[_c('div',{staticClass:"wrap"},[_c('p',{staticClass:"wrong__text"},[_vm._v("There's nothing here ¯\\_(ツ)_/¯")])])])
}]

export { render, staticRenderFns }